export const mainResponsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1025 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 1024, min: 769},
      items: 1
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };